<template>
  <div v-if="show" class="modal-overlay" @click.self="fechar">
    <div class="modal-container">
      <div class="modal-header">
        <h2>{{ empresa ? 'Editar Empresa' : 'Nova Empresa' }}</h2>
        <button class="btn-close" @click="fechar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label class="form-label">Nome *</label>
          <input
            v-model="form.nome"
            type="text"
            class="form-input"
            placeholder="Nome da empresa"
            maxlength="200"
          />
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">CNPJ</label>
            <input
              v-model="form.cnpj"
              type="text"
              class="form-input"
              placeholder="00.000.000/0000-00"
              maxlength="18"
            />
          </div>

          <div class="form-group">
            <label class="form-label">Telefone</label>
            <input
              v-model="form.telefone"
              type="text"
              class="form-input"
              placeholder="(00) 00000-0000"
              maxlength="20"
            />
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Email</label>
          <input
            v-model="form.email"
            type="email"
            class="form-input"
            placeholder="contato@empresa.com"
            maxlength="100"
          />
        </div>

        <div class="form-group">
          <label class="form-label">Endereço</label>
          <textarea
            v-model="form.endereco"
            class="form-textarea"
            placeholder="Endereço completo"
            rows="3"
            maxlength="500"
          ></textarea>
        </div>

        <div class="form-group">
          <label class="form-checkbox">
            <input type="checkbox" v-model="form.ativo" />
            <span>Empresa ativa</span>
          </label>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn-secondary" @click="fechar">Cancelar</button>
        <button class="btn-primary" @click="salvar" :disabled="salvando || !form.nome.trim()">
          <span v-if="!salvando">Salvar</span>
          <span v-else>Salvando...</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: 'ModalEmpresa',
  props: {
    show: Boolean,
    empresa: Object
  },
  data() {
    return {
      form: {
        nome: '',
        cnpj: '',
        telefone: '',
        email: '',
        endereco: '',
        ativo: true
      },
      salvando: false
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.resetForm();
      }
    }
  },
  methods: {
    resetForm() {
      if (this.empresa) {
        this.form = {
          nome: this.empresa.nome || '',
          cnpj: this.empresa.cnpj || '',
          telefone: this.empresa.telefone || '',
          email: this.empresa.email || '',
          endereco: this.empresa.endereco || '',
          ativo: this.empresa.ativo ?? true
        };
      } else {
        this.form = {
          nome: '',
          cnpj: '',
          telefone: '',
          email: '',
          endereco: '',
          ativo: true
        };
      }
    },
    async salvar() {
      if (!this.form.nome.trim()) {
        this.$swal({
          icon: 'warning',
          title: 'Atenção',
          text: 'O nome da empresa é obrigatório.',
        });
        return;
      }

      this.salvando = true;

      try {
        const request = {
          Nome: this.form.nome,
          Cnpj: this.form.cnpj || null,
          Telefone: this.form.telefone || null,
          Email: this.form.email || null,
          Endereco: this.form.endereco || null,
          Ativo: this.form.ativo
        };

        if (this.empresa) {
          // Editar
          request.Id = this.empresa.id;
          await api.put(`/empresa/${this.empresa.id}`, request, {
            withCredentials: true
          });
        } else {
          // Criar
          await api.post('/empresa', request, {
            withCredentials: true
          });
        }

        this.$swal({
          icon: 'success',
          title: 'Sucesso!',
          text: `Empresa ${this.empresa ? 'atualizada' : 'criada'} com sucesso.`,
          timer: 2000,
          showConfirmButton: false
        });

        this.salvando = false;
        this.$emit('salvo');
      } catch (error) {
        this.salvando = false;
        console.error('Erro ao salvar empresa:', error);

        this.$swal({
          icon: 'error',
          title: 'Erro ao salvar',
          text: error.response?.data?.message || error.response?.data?.Message || 'Ocorreu um erro ao salvar a empresa.',
        });
      }
    },
    fechar() {
      if (!this.salvando) {
        this.$emit('close');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.modal-container {
  background: white;
  border-radius: 16px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 2px solid #f3f4f6;

  h2 {
    font-size: 1.5rem;
    font-weight: 700;
    color: #00235C;
  }
}

.btn-close {
  padding: 0.5rem;
  background: transparent;
  border: none;
  color: #6b7280;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: #f3f4f6;
    color: #00235C;
  }
}

.modal-body {
  padding: 2rem;
  overflow-y: auto;
  flex: 1;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 0.9375rem;
  color: #1f2937;
  font-family: 'Inter', sans-serif;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #00235C;
    box-shadow: 0 0 0 3px rgba(0, 35, 92, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
}

.form-textarea {
  resize: vertical;
  min-height: 80px;
}

.form-checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  user-select: none;

  input[type="checkbox"] {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  span {
    font-size: 0.9375rem;
    color: #374151;
    font-weight: 500;
  }
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1.5rem 2rem;
  border-top: 2px solid #f3f4f6;
}

.btn-secondary,
.btn-primary {
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-secondary {
  background: white;
  border: 2px solid #e5e7eb;
  color: #6b7280;

  &:hover {
    background: #f9fafb;
    border-color: #6b7280;
  }
}

.btn-primary {
  background: linear-gradient(135deg, #00235C 0%, #001a45 100%);
  border: none;
  color: white;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 35, 92, 0.3);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>
